import * as _ from 'lodash'
import axios from 'axios'
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {
    IMetricParameterSet,
    IMetricParameters,
    IMetricService,
    IMetricsSet,
    IMetrics,
    IMetricDetails, IMetricDetailsSet, IMetricDetailsOptions
} from "./PA.Metrics.IF"
import {MetricsSet, Metrics, MetricsParameterSet, MetricDetailsSet} from './PAMetrics'
import {PAdbContext} from "../PA.Core/PAdbContext";
import {PAMetricUtils} from "./PAMetricUtils";

let msDbContext: PAdbContext = undefined

export class PAMetricServiceClient implements IMetricService {

    constructor() {
        // No state needed.., static implementation

    }


    calculateMetric(metric_parameter: IMetricParameters): Promise<IMetrics> {
        return PAMetricServiceClient.staticCalculateMetric(metric_parameter)
    }

    calculateMetricSet(metric_parameter_set: IMetricParameterSet): Promise<IMetricsSet> {
        return PAMetricServiceClient.staticCalculateMetricSet(metric_parameter_set)
    }

    calculateMetricDetails(metric_parameter: IMetricParameters, detailOptions: IMetricDetailsOptions): Promise<IMetricDetails> {
        return PAMetricServiceClient.staticCalculateMetricDetails(metric_parameter, detailOptions)
    }


    calculateMetricDetailsSet(metric_parameter_set: IMetricParameterSet, detailOptions: IMetricDetailsOptions): Promise<IMetricDetailsSet> {
        return PAMetricServiceClient.staticCalculateMetricDetailsSet(metric_parameter_set, detailOptions);
    }


    calculateMetricUnion(metric_parameters: IMetricParameters[]): Promise<IMetrics[]> {
        return PAMetricServiceClient.staticCalculateMetricUnion(metric_parameters);
    }

    calculateMetricUnionDetails(metric_parameters: IMetricParameterSet, detailOptions: IMetricDetailsOptions): Promise<IMetricDetailsSet> {
        return PAMetricServiceClient.staticCalculateMetricUnionDetails(metric_parameters, detailOptions)
    }


    static staticCalculateMetric(metric_parameter: IMetricParameters): Promise<IMetrics> {
        return new Promise<IMetrics>((resolve, error) => {
            var temp = new MetricsParameterSet()
            temp["Temp"] = metric_parameter
            PAMetricServiceClient.staticCalculateMetricSet(temp)
                .then((result) => {
                    resolve(result["Temp"])
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static staticCalculateMetricSet(metric_parameter_set: IMetricParameterSet): Promise<IMetricsSet> {

        return new Promise<IMetricsSet>((resolve, error) => {

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'metrics';
            else
                sEndPoint += '/metrics';

            PAMetricUtils.staticMetricParameterSet_preProcess(metric_parameter_set)
                .then(() => {
                    return axios.post(sEndPoint, {data: {MetricParameterSet: metric_parameter_set}})
                })
                .then((resp: any) => {
                    try {

                        var jsonMetricSet = resp.data;
                        if (typeof jsonMetricSet === 'string') {
                            jsonMetricSet = JSON.parse(jsonMetricSet);
                        }

                        var metricSet = MetricsSet.parseJSON(jsonMetricSet)
                        resolve(metricSet);
                    } catch (err) {
                        error(err)
                    }
                })
                .catch((err: any) => {
                    error('Unable to obtain Metric Results from Server. ' + err);
                });
        });
    }


    static staticCalculateMetricDetails(metric_parameter: IMetricParameters, detailOptions: IMetricDetailsOptions): Promise<IMetricDetails> {
        return new Promise<IMetricDetails>((resolve, error) => {
            var temp = new MetricsParameterSet()
            temp["Temp"] = metric_parameter
            PAMetricServiceClient.staticCalculateMetricDetailsSet(temp, detailOptions)
                .then((result) => {
                    resolve(result["Temp"])
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static staticCalculateMetricDetailsSet(metric_parameter_set: IMetricParameterSet, detailOptions: IMetricDetailsOptions): Promise<IMetricDetailsSet> {


        return new Promise<IMetricDetailsSet>((resolve, error) => {

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'metrics';
            else
                sEndPoint += '/metrics';

            PAMetricUtils.staticMetricParameterSet_preProcess(metric_parameter_set)
                .then(() => {
                    return axios.post(sEndPoint, {
                        data: {
                            MetricParameterSet: metric_parameter_set,
                            DetailOptions: detailOptions
                        }
                    })
                })
                .then((resp: any) => {
                    try {

                        let jsonMetricDetailSet = resp.data;
                        if (typeof jsonMetricDetailSet === 'string') {
                            jsonMetricDetailSet = JSON.parse(jsonMetricDetailSet);
                        }

                        let metricDetailSet = MetricDetailsSet.parseJSON(jsonMetricDetailSet)
                        resolve(metricDetailSet);
                    } catch (err) {
                        error(err)
                    }
                })
                .catch((err: any) => {
                    error('Unable to obtain Metric Details Results from Server. ' + err);
                });
        });

    }


    static staticCalculateMetricUnion(metric_parameters: IMetricParameters[]): Promise<IMetrics[]> {
        return new Promise<IMetrics[]>((resolve, error) => {

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'metricsUnion';
            else
                sEndPoint += '/metricsUnion';

            async function preProcess() {
                let i=0
                for (let aSet of metric_parameters) {
                    let set = new MetricsParameterSet()
                    set[i] = aSet
                    await PAMetricUtils.staticMetricParameterSet_preProcess(set)
                    i++
                }
            }

            preProcess()
                .then(() => {
                    return axios.post(sEndPoint, {
                        data: {
                            MetricParameterSets: metric_parameters
                        }
                    })
                })
                .then((result: any) => {
                    resolve(result)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    static staticCalculateMetricUnionDetails(metric_parameters: IMetricParameterSet, detailOptions?: IMetricDetailsOptions): Promise<IMetricDetailsSet> {


        return new Promise<IMetricDetailsSet>((resolve, error) => {

            let sEndPoint = <string>(PAEnvironment.getValue(PAEnvironment.Network_URL_Base, "/"));
            if (sEndPoint.endsWith('/'))
                sEndPoint += 'metricsUnion';
            else
                sEndPoint += '/metricsUnion';
            PAMetricUtils.staticMetricParameterSet_preProcess(metric_parameters)
                .then(() => {
                    return axios.post(sEndPoint, {
                        data: {
                            MetricParameterSets: metric_parameters,
                            DetailOptions: detailOptions
                        }
                    })
                })
                .then((resp: any) => {
                    try {

                        let jsonMetricDetailSet = resp.data;
                        if (typeof jsonMetricDetailSet === 'string') {
                            jsonMetricDetailSet = JSON.parse(jsonMetricDetailSet);
                        }

                        resolve(jsonMetricDetailSet);
                    } catch (err) {
                        error(err)
                    }
                })
                .catch((err: any) => {
                    error('Unable to obtain Metric Details Results from Server. ' + err);
                });
        });

    }


}
